import { render, staticRenderFns } from "./template-1.vue?vue&type=template&id=1b7bbfe8&scoped=true"
import script from "./template-1.vue?vue&type=script&lang=js"
export * from "./template-1.vue?vue&type=script&lang=js"
import style0 from "./template-1.vue?vue&type=style&index=0&id=1b7bbfe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7bbfe8",
  null
  
)

export default component.exports